export const PROVIDER_MODELS: Record<string, Array<{ value: string; label: string }>> = {
  claude: [
    { value: 'claude-sonnet-4-6',          label: 'Claude Sonnet 4.6 (recommended)' },
    { value: 'claude-opus-4-8',            label: 'Claude Opus 4.8 (most capable)'  },
    { value: 'claude-haiku-4-5-20251001',  label: 'Claude Haiku 4.5 (fastest)'      },
  ],
  openai: [
    { value: 'gpt-4o',        label: 'GPT-4o (recommended)'     },
    { value: 'gpt-4o-mini',   label: 'GPT-4o Mini'              },
    { value: 'gpt-4-turbo',   label: 'GPT-4 Turbo'              },
    { value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo (cheapest)' },
  ],
  groq: [
    { value: 'llama-3.3-70b-versatile', label: 'LLaMA 3.3 70B (recommended)' },
    { value: 'llama-3.1-8b-instant',    label: 'LLaMA 3.1 8B Instant (fastest)' },
  ],
  azureopenai: [
    { value: 'gpt-4o',      label: 'GPT-4o'       },
    { value: 'gpt-4-turbo', label: 'GPT-4 Turbo'  },
    { value: 'gpt-4',       label: 'GPT-4'         },
  ],
};
